import getServiceCities from '../api/getServiceCities'
import getServiceRequestsStatuses from '../api/getServiceRequestsStatuses'
import getBrands from '../api/getBrands'
import Select, {Option} from './Select'
import {InputBase_v2} from './InputBase_v2'
import {always, constructN, defaultTo, map, omit, pipe, prop, toString} from 'ramda'
import {getAbilityPromise} from '../defineAbility'
import {Select2ServiceCity} from './Select2ServiceCity'
import {Select2PopularClients} from './Select2PopularClients'
import {updateStatuses} from "~/api/requests";

const emptyObject = always({})
const noop = always(undefined)
/** @type { import('@casl/ability').Ability } */
let ability
getAbilityPromise.then((_ability) => ability = _ability)
const getURLSearchParams = pipe(
	constructN(1, URLSearchParams),
	toString,
)

const SelectField = {
	functional: true,
	props: {
		label: String,
		multiple: Boolean,
		...Select.props
	},
	render(h, {props, data, children, listeners}) {
		const change = defaultTo(noop, listeners.change)

		return (
			<div class="input-block" {...omit(['on'], data)}>
				<Select
					class="input-block__input"
					onChange={({target}) => {
						const collection = target.selectedOptions;
						if (!collection.length) {
							return change(null)
						} else if (collection.length <= 1) {
							return change(collection[0].value)
						} else {
							return change(map(prop("value"), collection))
						}
					}}
					{...{props}}
				>
					{children}
				</Select>
				<label
					class="label input-block__label"
					for=""
				>
					{props.label}
				</label>
			</div>
		)
	}
}

const getExcel = (params) => {

	let result = [];

	let testObj = Object.assign({}, params);

	for (let prop in testObj) {
		if (Array.isArray(testObj[prop])) {
			let propArray = testObj[prop].map(item => ['status[]', item]);
			result.push(...propArray)
		} else result.push([prop, testObj[prop]])
	}

	window.open(`/api/Requests/getExcel/?${getURLSearchParams(result)}`, '_blank')
}

const FormServiceRequestsFilter = {
	name: 'FormServiceRequestsFilter',
	props: {
		initialValues: {
			type: Object,
			default: emptyObject,
		},
	},
	data: (vm) => ({
		brands: [],
		cities: [],
		statuses: [],
		form: vm.initialValues,
	}),
	watch: {
		initialValues: function (newValues) {
			this.form = newValues
		},
	},
	methods: {
		changeStatusesInSelectedRequests() {
			const changeStatusId = document.getElementById('MASS_UPDATE_STATUS').querySelector('select');
			const selectedRequests = document.querySelectorAll('input[name=MASS_UPDATE]:checked');
			if (!changeStatusId || selectedRequests.length === 0) return;

			let requests = [];
			selectedRequests.forEach(e => {
				requests.push(e.value)
			})

			updateStatuses(requests, changeStatusId.value).then(() => {
				this.form.rand = Date.now();
				this.$emit('finish', this.form);
			});
		}
	},
	mounted() {
		this.$options.map = new Map(),
			Promise.all([
				getBrands(),
				getServiceCities(),
				getServiceRequestsStatuses()
			]).then(([brands, cities, statuses]) => {
				this.brands = brands
				this.cities = cities
				this.statuses = statuses
			})
	},
	render(h) {
		const setProp = (prop, value) => this.$set(this.form, prop, value)

		return (
			<form
				class="form-service form-service-requests-filter"
				onSubmit={event => event.preventDefault()}
			>
				<SelectField
					label="Производитель"
					emptyOption
					defaultValue={this.form.brand}
					onChange={value => setProp('brand', value)}
				>
					{map(({ID, NAME}) => (
						<Option value={ID}>
							{NAME}
						</Option>
					), this.brands)}
				</SelectField>
				<Select2ServiceCity
					label="Город"
					value={this.form.city}
					onSelect={value => setProp('city', value.id)}
					disabled={ability.cannot('view', 'Request', 'CITY')}
				/>
				<SelectField
					label="Заявки, которые не менялись"
					emptyOption
					defaultValue={this.form.change}
					onChange={value => setProp('change', value)}
				>
					<Option value="3">
						3 дня
					</Option>
					<Option value="4">
						4 дня
					</Option>
				</SelectField>
				<InputBase_v2
					label="Номер заявки"
					vModel_trim={this.form.requestNumber}
				/>
				<InputBase_v2
					label="Серийный номер"
					vModel_trim={this.form.serialNumber}
				/>
				<InputBase_v2
					label="Заказ-наряд"
					vModel_trim={this.form.order}
				/>
				<Select2PopularClients
					label="Популярные клиенты"
					value={this.form.client}
					onSelect={(value) => setProp('client', value.id)}
				/>
				<InputBase_v2
					label="Номер телефона клиента"
					vModel_trim={this.form.phone}
				/>
				<div class="form-service-requests-filter-row-span-2">
					<SelectField
						label="Статус заявки"
						multiple
						defaultValue={this.form.status}
						onChange={value => setProp('status', value)}
					>
						{map(({ID, NAME}) => (
							<Option value={ID}>
								{NAME}
							</Option>
						), this.statuses)}
					</SelectField>
				</div>
				<div class="form-service-requests-filter-column-span-2">
					<div class="form-service-requests-filter-field-date">
						<span class="form-service-requests-filter-field-date-label">
							Дата создания заявки
						</span>
						<InputBase_v2
							class="form-service-requests-filter-field-date-input"
							type="date"
							vModel={this.form.dateStart}
						/>
						—
						<InputBase_v2
							class="form-service-requests-filter-field-date-input"
							type="date"
							vModel={this.form.dateEnd}
						/>
					</div>
				</div>
				<div class="form-service-requests-filter-column-span-2">
					<button
						class={[
							'button button_theme_secondary-ghost',
							'form-service-requests-filter-button-submit',
						]}
						type="button"
						onClick={() => this.$emit('finish', this.form)}
					>
						Найти
					</button>
					<button
						class="button button_theme_secondary-ghost"
						type="reset"
						onClick={() => this.$emit('finish', {})}
					>
						Сбросить
					</button>
				</div>
				{ability.can('download', 'Request') ? (
					<button
						class={[
							'button button_theme_secondary-ghost',
							'form-service-requests-filter-button-download',
						]}
						type="button"
						onClick={() => getExcel(this.form)}
					>
						Excel
					</button>
				) : null}

				{ability.can('view', 'Request', 'MASS_UPDATE') ? (
					<SelectField
						label="Новый статус заявки"
						id="MASS_UPDATE_STATUS"
					>
						{map(({ID, NAME}) => (
							<Option value={ID}>
								{NAME}
							</Option>
						), this.statuses)}
					</SelectField>
				) : null}

				{ability.can('view', 'Request', 'MASS_UPDATE') ? (
					<button
						class={[
							'mt-4 button button_theme_secondary-ghost',
							'form-service-requests-filter-button-status-change',
						]}
						type="button"
						onClick={() => this.changeStatusesInSelectedRequests()}
					>
						Сменить статус выбранных заявок
					</button>
				) : null}
			</form>
		)
	},
}

export default FormServiceRequestsFilter
